import useDownloadPdf from './useDownloadPdf';

export interface CgvPayload {
  channel: string;
}

export const useDownloadCgv = () => {
  const { download, loading, error } = useDownloadPdf<CgvPayload>(
    '/communication/cgv/pdf',
    'cgv.pdf',
    'Erreur lors du téléchargement des CGV',
  );
  return { downloadCgv: download, loading, error };
};
